<template>
    <v-dialog v-model="dialog"
              @click:outside="closeDialog"
              max-width="800px"
              scrollable
    >
        <v-card>
            <v-toolbar dense flat>
                <v-toolbar-title class="text-primary-700">{{item ? item.name : ''}} Properties</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-6" v-if="item">
                
                <div v-if="item.properties.data.length">
                    <!-- <h3>Properties</h3> -->
                    <v-simple-table style="width:100%; border: 1px solid #e0e0e0; border-radius: 4px;">
                        <template v-slot:default>
                            <thead>
                            <tr>
                                <th></th>
                                <th>Unit</th>
                                <th>Address</th>
                                <th>Scheme</th>
                                <th>Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(property, index) in item.properties.data" :key="index">
                                <td>
                                    <v-icon v-if="property.core_id" title="Synced with RPD Data">
                                        mdi-cloud-check-outline
                                    </v-icon>
                                </td>
                                <td>{{ property.building_num }}</td>
                                <td>{{ property.address.full_address}}</td>
                                <td>{{ property.scheme.name}}</td>
                                <td class="text-center">
                                    <v-icon v-if="property.scheme_id" @click="routeToEdit(property.scheme.id)"
                                            small
                                            class="mr-2"
                                    >
                                        mdi-pencil
                                    </v-icon>
                                  <v-icon v-else @click="$refs.editStandalonePropertyDialog.showDialog(property.id)"
                                          small
                                          class="mr-2"
                                  >
                                    mdi-pencil
                                  </v-icon>
                                    <v-icon v-if="property.scheme_id" @click="routeToMap(property.scheme)" small title="View on map">
                                        mdi-google-maps
                                    </v-icon>
                                </td>
                            </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </div>
                
                <edit-scheme-dialog ref="editSchemeDialog"></edit-scheme-dialog>
              <edit-standalone-property-dialog ref="editStandalonePropertyDialog" ></edit-standalone-property-dialog>
            </v-card-text>
            <v-card-text v-else>
                <v-skeleton-loader type="table" :loading="true" class="pa-6">
                    <template #item.default="{ active }">
                        <v-simple-table style="width:100%; border: 1px solid #e0e0e0; border-radius: 4px;">
                            <template v-slot:default>
                                <thead>
                                <tr>
                                    <th></th>
                                    <th>Unit</th>
                                    <th>Address</th>
                                    <th>Scheme</th>
                                    <th>Actions</th>
                                </tr>
                                </thead>
                            </template>
                        </v-simple-table>
                    </template>
                </v-skeleton-loader>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
	import EditSchemeDialog from '@/components/schemes/editSchemeDialog'
  import EditStandalonePropertyDialog from "@/components/properties/editStandalonePropertyDialog";
	export default {
		name: "companyPropertiesDialog",
		components: {
      EditStandalonePropertyDialog,
			EditSchemeDialog
		},
		data: () => ({
			dialog: false,
			id: null,
			item: null,
		}),
		methods: {
			routeToEdit(id) {
				this.$refs.editSchemeDialog.showDialog(id);
				// this.$router.push({name: 'companies.edit', params: {id: id}})
			},
			routeToMap(item) {
				this.$router.push({name: 'map', params: {scheme: item}})
			},
			showDialog: function (id) {
				this.dialog = true;
				this.id = id;
				this.getItem();
			},
			async getItem() {
				const {data} = await this.$http.get(`/companies/${this.id}`, {
					params: {
						include: 'properties.address,properties.scheme',
					}
				});

				this.item = data;
			},
			closeDialog: function () {
				this.dialog = false;
				this.id = null;
				this.item = null;
				this.$emit('closed');
			},
		},
	}
</script>

<style scoped>

</style>
